import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, costFormater, PriceInput, SaveCancelControls } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { EditableBadge } from '@/modules/UseMyMoney/components';
import { useMyMoneyFormStore } from '@/modules/UseMyMoney/stores';

const HsaAmountFieldSetup = () => {
  const { t } = useTranslation();
  const { values, handleSetFormValues } = useMyMoneyFormStore();

  const [amount, setAmount] = useState(values?.customAmount || '');
  const [isEditMode, setIsEditMode] = useState(false);

  const handleChangeAmount = useCallback((amount: string) => {
    handleSetFormValues({ amount, customAmount: amount });
    setIsEditMode(false);
  }, [handleSetFormValues]);

  const handleSave = useCallback(() => {
    const newAmount = toNumber(amount) ? amount : '';
    handleSetFormValues({ amount: newAmount, customAmount: newAmount });
    setIsEditMode(false);
  }, [handleSetFormValues, amount]);

  const handleCancel = useCallback(() => {
    handleSetFormValues({ amount: '', customAmount: '' });
    setAmount('');
  }, [handleSetFormValues]);

  return (
    <Box>
      <EditableBadge
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        isSelected={Number(values?.amount) === Number(values?.customAmount)}
        value={values?.customAmount || ''}
        title={values?.customAmount ? `${costFormater(toNumber(values?.customAmount), true)}` : undefined}
        onChangeValue={handleChangeAmount}
        border={undefined}
        pad={{ left: 'spacing16', right: 'spacing12', vertical: 'spacing8' }}
        pencilIconProps={{ color: 'iconPrimary', size: '24px' }}
        textProps={{ size: '20px' }}
      >
        <Box width="160px">
          <SaveCancelControls
            testId="amount"
            onSave={handleSave}
            onCancel={handleCancel}
          >
            <PriceInput
              name="amount"
              testId="amount"
              value={amount}
              onChange={setAmount}
              placeholder={t('Enter $ amount')}
              disableBrowserHints
            />
          </SaveCancelControls>
        </Box>
      </EditableBadge>
    </Box>
  );
};

export default HsaAmountFieldSetup;
